export default {
    cost_center: {
        label: "Cost Center Code",
        placeholder: "Cost Center Code",
    }
}